<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { ProjectWorkspaceSwitcherViewModel } from '@Projects/Components/ProjectWorkspaceSwitcher'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: ProjectWorkspaceSwitcherViewModel
    }>()

    const emit = defineEmits<{
        (e: 'move-project', projectId: number, newWorkspaceId: number): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value.initialized)
    const workspaces = computed(() => vm.value.workspaces)

    const workspaceId = computed(() => vm.value.workspaceId)
    const projectName = computed(() => vm.value.projectName)

    const newWorkspaceId = computed<number>({
        get: () => vm.value.newWorkspaceId,
        set: val => { vm.value.newWorkspaceId = val }
    })

    // ---------------- methods ----------------

    function handleMoveProject()
    {
        if (newWorkspaceId.value !== workspaceId.value)
        {
            emit('move-project', vm.value.projectId, newWorkspaceId.value)
        }
    }

    function close()
    {
        vm.value.close()
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Switch Workspace for Your Project</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h4 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Loading...</h4>
                        <div v-if="initialized">
                            <p>Move your project <strong>'{{projectName}}'</strong> to a different workspace. Select the destination workspace from the list below.</p>
                            <p>
                                <select v-model="newWorkspaceId" class="form-control">
                                    <option v-for="w in workspaces" :value="w.WorkspaceId">{{w.Name}}</option>
                                </select>
                            </p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="handleMoveProject" :disabled="newWorkspaceId === workspaceId" class="btn btn-primary">Save</button>
                        <button type="button" @click="close" class="btn btn-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

